var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDescLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.521 33.385h3.043c.843 0 1.521-.679 1.521-1.522s-.678-1.521-1.52-1.521H5.52c-.843 0-1.521.678-1.521 1.521 0 .843.678 1.522 1.521 1.522zm0-8.114h7.1c.843 0 1.521-.679 1.521-1.522s-.678-1.521-1.521-1.521h-7.1c-.843 0-1.521.678-1.521 1.521 0 .843.678 1.522 1.521 1.522zm0-8.114h11.157c.843 0 1.521-.679 1.521-1.522s-.678-1.521-1.521-1.521H5.521c-.843 0-1.521.678-1.521 1.521 0 .843.678 1.522 1.521 1.522zm0-8.114h15.214c.843 0 1.521-.679 1.521-1.522S21.578 6 20.735 6H5.521C4.678 6 4 6.678 4 7.521c0 .843.678 1.522 1.521 1.522z"
  })));
}
export default SvgSortDescLeft;